<script>
import Layout from "../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import CreateCompany from "@/components/passport_account/CreateCompany";
import ChangeImg from "@/components/passport_account/ChangeImg";
import ChangeName from "@/components/passport_account/ChangeName";
import ChangeCompanyName from "@/components/passport_account/ChangeCompanyName";
import ChangePassword from "@/components/passport_account/ChangePassword";
import ChangePhone from "@/components/passport_account/ChangePhone";
import ChangeEmail from "@/components/passport_account/ChangeEmail";
import validateUserPassword from "@/components/passport_account/validateUserPassword";
import DeactiveAccount from "@/components/passport_account/DeactiveAccount";
// import ChangePrimaryCompany from "@/components/passport_account/ChangePrimaryCompany";
import AcceptInvitation from "@/components/passport_account/AcceptInvitation";
import RejectInvitation from "@/components/passport_account/RejectInvitation";
import ComplianceFillIn from "@/components/dashboard/complianceFillIn";
import TwoStepAuthenticationModal from "@/components/passport_account/TwoStepAuthenticationModal";
import VerifyOtpCode from "@/components/passport_account/VerifyOtpCode";
import OtpAuthAppliedMessage from "@/components/passport_account/OtpAuthAppliedMessage";
import { sliceLongString } from "@/utils/mixins/sliceLongString";
// import userService from "../../services/userService";
import { onMessage } from "firebase/messaging";
import { messaging } from '@/firebase';

import {
  DxDataGrid,
  DxFilterRow,
  DxHeaderFilter,
  DxColumn,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
// import CustomStore from "devextreme/data/custom_store";
import "devextreme/data/odata/store";
import moment from "moment";
const dataGridRefKey = "my-data-grid";
const dataGridRefKey2 = "my-data-grid2";

export default {
  mixins: [sliceLongString],
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "Dashboard",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    CreateCompany,
    ChangeImg,
    ChangeName,
    ChangeCompanyName,
    ChangePassword,
    TwoStepAuthenticationModal,
    VerifyOtpCode,
    OtpAuthAppliedMessage,
    ChangePhone,
    ChangeEmail,
    validateUserPassword,
    DeactiveAccount,
    // ChangePrimaryCompany,
    AcceptInvitation,
    RejectInvitation,
    ComplianceFillIn,
    DxDataGrid,
    DxFilterRow,
    DxHeaderFilter,
    DxColumn,
    DxPager,
    DxPaging,
  },
  data() {
    return {
      allUserEntities: [],
      userEntities: [],
      defaultCompany: null,
      firstAttempt: false,
      defaultSignedIn: false,
      currentPage: 1,
      title: "",
      isAdmin: false,
      searchName: "",
      userTimezone: "",
      user: null,
      atex: null,
      imageToDisplay:
        "https://vp5-passport.s3.eu-west-2.amazonaws.com/profiles/file-uploader-api-profile-avatar-2.jpg",
      hasImage: false,
      imgSpinner: false,
      columns: {
        Status: "Status",
        "User Type": "User Type",
      },
      editData: false,
      systemUser: null,
      qr: null,
      entities: [],
      usersInvitations: [],
      allowedOperations: ["contains"],
      normalEntities: [],
      pageSizes: [5, 10],
      pageSizes2: [5, 10, 20],
      dataGridRefKey,
      dataGridRefKey2,
      entrylogsShow: true,

      // online compliance
      visit_url: null,
      server_url: null,
      firstName: null,
      lastName: null,
      siteName: null,
      areaName: null,
      userTypeForUser: null,
      visitDate: null,
      visitTime: null,
      userId: null,
      visitId: null,
      entityId: null,
      registrationMethod: null,
      journeyStage: null,
      userDetails : null,
      userEntitiesIds : [],
      type : '',
    };
  },
  watch: {
    // getUpdateLoading(val) {
    //   if (!val) {
    //     this.fetchAllUserEntities().then(data => {
    //       this.userEntities = data.data.data.filter(item => item.pivot.is_active == 1 && item.package == "Cloud");
    //       this.defaultCompany = data.data.data.find(item => !!item.is_default);
    //         this.firstAttempt = false;
    //         // this.$bvModal.hide('changePrimaryCompany');
    //     });
    //   }
    // },
    getCompFetched(val) {
      if (val && !this.$route.query.add_visitor) {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
    getUserVisits(visits) {
      console.log("watch", visits);
      if (this.$route.query.onlineCompliance) {
        setTimeout(() => {
          document.getElementById("preloader").style.display = "block";
          document.getElementById("status").style.display = "block";
        }, 500);
      }
      if (
        this.$route.query.onlineCompliance &&
        visits &&
        visits.expected_scans &&
        visits.expected_scans.length > 0
      ) {
        // onlineCompliance=true&expectedVisit=true&visitId=2de7293e-3954-4c5c-9e4f-4af4156ca11c
        console.log("visits", visits);
        const visit = visits.expected_scans.find(
          (item) =>
            item.metadata &&
            item.metadata.visit_url == this.$route.query.visitUrl
        );
        this.viewCompliance(visit);
      } else if (this.$route.query.onlineCompliance && visits &&
        visits.expected_scans &&
        visits.expected_scans.length == 0) {
        let msg = "Your compliance link has expired because you have already arrived at the area. Please contact the system admin for further details.";
        this.setCompExpiryMsg(msg);
        this.$router.push("/compliance-link-expired");
      }
      // console.log("watchhh", visits);
    },
    getUserEntities(entities) {
      // console.log('entities', entities);
      this.userEntitiesIds = [];
      this.usersInvitations = [];
      this.normalEntities = [];
      if(entities && entities.length){
        entities.map((entity) => {
          this.userEntitiesIds.push(entity.entity_id)
          if(entity.pivot.status == 2 && entity.pivot){
            this.usersInvitations.push(entity)
          }else if(entity.pivot && entity.pivot.status != 2 && entity.pivot.is_sys_user){
            this.normalEntities.push(entity)
          }
        })
      }
      console.log('userEntitiesIds', this.userEntitiesIds);  
    },
    searchName(value) {
      if (!value || (value && value.length == 0)) {
        this.fetchUserEntities();
      }
    },
    getUserQr(updatedQr) {
      this.qr = updatedQr ? updatedQr.replace(/\.[^/.]+$/, "") : null;
    },
  },
  computed: {
    ...mapGetters("entities", [
      "getUserEntities",
      "getTotalRows",
      "getPerPage",
    ]),
    ...mapGetters("user", [
      // "getUpdateLoading",
      "getShowDeactivateAccountModal",
      "getIp",
      "getUserNewImage",
      "getUserFirstName",
      "getUserLastName",
      "getUserPhone",
      "getUserEmail",
      "getUserTimeZone",
      "getTmpPwd",
      "getUserData",
      "getUserVisits",
      "getUserQr",
    ]),
    ...mapGetters("compliance", ["getComplianceCreated", "getCompFetched"]),
    dataGrid: function() {
      return this.$refs[dataGridRefKey].instance;
    },
  },
  methods: {
    ...mapActions("entities", [
      "fetchUserEntities",
      "fetchAllUserEntities",
      "clearStoredPendingInvitation",
      "getUserProfile",
    ]),
    ...mapActions("user", ["getUserIpAction", "fetchUserVisits"]),
    ...mapActions("modal", ["setData"]),
    ...mapActions("entity", ["checkEntityStatus"]),
    ...mapActions("authfack", ["resetUsername", "fetchuserDetails", "logout"]),
    ...mapActions("compliance", ["fetchUserOnlineCompliance", "setCompExpiryMsg"]),
    viewCompliance(data) {
      console.log("viewCompliance", data);
      if (!data) {
        let msg = "Your compliance link has expired because you have already arrived at the area. Please contact the system admin for further details.";
        this.setCompExpiryMsg(msg);
        this.$router.push("/compliance-link-expired");
        return;
      }
      this.visit_url = data.metadata.visit_url;
      this.server_url = data.server_url;
      this.fetchUserOnlineCompliance({ id: data.metadata.visit_url, server_url: data.server_url })
        .then((data) => {
          this.firstName = data.data.data.data.firstName;
          this.lastName = data.data.data.data.lastName;
          this.siteName = data.data.data.data.siteName;
          this.areaName = data.data.data.data.areaName;
          this.userTypeForUser = data.data.data.data.userTypeName;
          this.visitDate = data.data.data.data.visitDate;
          this.visitTime = data.data.data.data.visitTime;
          this.userId = data.data.data.data.userId;
          this.visitId = data.data.data.data.visitId;
          this.entityId = data.data.data.data.entityId;
          this.usertypeId = data.data.data.data.usertypeId;
          this.registrationMethod = data.data.data.data.registrationMethod;
          this.journeyStage = data.data.data.data.journeyStage;
          this.$bvModal.show("visit_modal");
        })
        .catch((e) => console.log(e));
    },
    confirmVisit(data) {
      console.log("confirmVisit", data);
      window.location.href =
        data.serverFrontUrl +
        `/pre-registration/${data.metadata.visit_url}?` +
        `add_visitor=${true}&comingFromPassport=${true}` +
        '&first_name=' + encodeURIComponent(this.getUserData.first_name) +
        '&last_name=' + encodeURIComponent(this.getUserData.last_name) +
        (this.getUserData.id
          ? "&passport_id=" + encodeURIComponent(this.getUserData.id)
          : "") +
        (this.getUserData.passport_qr
          ? "&passport_qr=" + encodeURIComponent(this.getUserData.passport_qr)
          : "");
    },
    setImage: function(output) {
      if (output.info.orgHeight <= 300 || output.info.orgWidth <= 250) {
        this.imgMinSizeErr = true;
      } else {
        this.imgMinSizeErr = false;
        this.hasImage = true;
        const obj = this.dataURLtoFile(output.dataUrl, output.info.name);
        this.form.user.image = obj;
      }
    },
    startImageResize() {
      this.imgSpinner = true;
    },
    endImageResize() {
      this.imgSpinner = false;
    },
    getBtnUrl(entity) {
      if (entity.pivot.status == "1" && entity.can_login) {
        return (
          entity.server.server_url +
          "/sso?id=" +
          entity.userId +
          "&atex=" +
          this.atex +
          "&entity_id=" +
          entity.entity_id +
          "&ip=" +
          this.getIp
        );
      } else {
        return "#";
      }
    },
    onEntityRedirect(entity) {
      // console.log('entity', entity);
      if(entity.can_login){
        const { getUserData: { id } } = this;
      this.checkEntityStatus({
        data: { user_id: id, entity_id: entity.entity_id },
        entity,
      });
      }else{
        this.$bvModal.show('OtpAuthAppliedMessageModal');
      }
    },
    getBtnClass(entity) {
      if (entity.pivot.status == "1") {
        return "active_entity";
      } else {
        return "revoked_entity";
      }
    },
    getBtnText(entity) {
      if (entity.pivot.status == "1") {
        return "Go";
      } else if (entity.pivot.status == "4") {
        return "Rejected";
      } else {
        return "Revoked";
      }
    },
    checkStringLengthWithCapitalize(string) {
      if (string && string.length > 20) {
        return (
          string && string.charAt(0).toUpperCase() + `${string.slice(0, 16)}...`
        );
      } else {
        return string && string.charAt(0).toUpperCase() + string.slice(1);
      }
    },
    getPaginatedEntities(pageNumber) {
      this.fetchUserEntities({ page: pageNumber, name: this.searchName });
    },
    searchByName(e) {
      this.fetchUserEntities({ name: e.target.value });
    },
    setUserData(data) {
      this.setData(data);
    },
    getUserTypeName(rowData) {
      return rowData.scan_user_type_name
        ? rowData.scan_user_type_name
        : rowData.entity_user_type;
    },
    getInputType(rowData) {
      return rowData.input_methods && rowData.input_methods.length > 0
        ? rowData.input_methods.join(" / ")
        : "-";
    },
    getHost(rowData) {
      let checkDeletedHost = rowData.host_user_id && rowData.host_user_id.includes("_deleted_user") ? true: false;
      if(checkDeletedHost || !rowData.host_user_id) return  "-"; 
      return rowData.host_name
        ? rowData.host_name + " (" + rowData.host_user_type + ")"
        : "-";
    },
    getDepartureTime(rowData) {
      return rowData.signed_out
        ? moment
            .utc(rowData.signed_out)
            .tz(this.userTimezone)
            .format("YYYY-MM-DD - hh:mm a")
        : "-";
    },
    getArrivalTime(rowData) {
      return rowData.signed_in
        ? moment
            .utc(rowData.signed_in)
            .tz(this.userTimezone)
            .format("YYYY-MM-DD - hh:mm a")
        : "-";
    },
    getExpectedTime(rowData) {
      return rowData.expected_visit_time
        ? moment
            .utc(rowData.expected_visit_time)
            .tz(this.userTimezone)
            .format("DD/MM/YYYY - hh:mm A")
        : "-";
    },
    getJourneyStage(rowData) {
      return rowData.journey_stage ? rowData.journey_stage : "-";
    },
    overrideOnValueChanged(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = "Search";
      }
    },
    renderDataGrid() {
      this.dataGrid.updateDimensions();
    },
    redirectToCloud() {
      if (this.$route.query.jf_id && this.$route.query.redirect_url) {
        console.log("with params");
        console.log(this.qr);
      } else {
        console.log("without params");
      }
    },
    showEntrylogs(value) {
      this.entrylogsShow = value;
    },
    async validationWithPassword(type){
      console.log('type', type);
      this.type = await type
      await this.setUserData(this.user);
      this.$bvModal.show('validateUserPasswordModal')
    }
  },
  beforeCreate() {
    if (this.$store.getters["auth/loggedIn"]) {
      this.$router.replace("/logout");
    }
  },
  created (){
    this.userDetails = localStorage.getItem("userDetails") ? localStorage.getItem("userDetails") : localStorage.getItem("user");
    this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(this.userDetails) : JSON.parse(this.userDetails).data.user;
  },
  async beforeMount() {
    // If user coming from cloud to fill preregistration form, redirect him/her to cloud again
    //  after sending user information on passport + the information that coming from cloud back
    if (this.$route.query.journey_flow_id && this.$route.query.redirect_url) {
      console.log("with params", this.getUserData);
      console.log(this.qr);
      if (this.$route.query.emailExists &&
        ((this.$route.query.email &&
          decodeURIComponent(this.$route.query.email) !=
            this.getUserData.email) ||
        (this.$route.query.phone &&
          decodeURIComponent(this.$route.query.phone) != this.getUserData.phone))
      ) {
        console.log('logout pleaseee');
        await this.logout({
          email: this.$route.query.email
            ? decodeURIComponent(this.$route.query.email)
            : decodeURIComponent(this.$route.query.phone),
          comingFromPassport: true,
          redirect_url: this.$route.query.redirect_url,
          visit_date: this.$route.query.visit_date,
          visit_time: this.$route.query.visit_time,
          area_id: this.$route.query.area_id,
          registration_method: this.$route.query.registration_method,
          entity_id: this.$route.query.entity_id,
          user_type_id: this.$route.query.user_type_id,
          journey_flow_id: this.$route.query.journey_flow_id,
          emailExists: true,
        });
        return;
      } else {
        console.log('elsee');
      window.location.href =
        this.$route.query.redirect_url +
        // `?comingFromPassport=${true}` +
        // "&user=" +
        // JSON.stringify(this.getUserData) +
        // "&preRegData=" +
        // JSON.stringify(this.$route.query);
        `?comingFromPassport=${true}` +
        "&first_name=" +
        encodeURIComponent(this.getUserData.first_name) +
        "&last_name=" +
        encodeURIComponent(this.getUserData.last_name) +
        `&getUserEntities=${this.getUserEntities.length > 0 ? true : false}` +
        (this.getUserData.encId
          ? "&encId=" + encodeURIComponent(this.getUserData.encId)
          : "") +
        (this.getUserData.id
          ? "&passport_id=" + encodeURIComponent(this.getUserData.id)
          : "") +
        (this.getUserData.email
          ? "&email=" + encodeURIComponent(this.getUserData.email)
          : "") +
        (this.getUserData.phone
          ? "&phone=" + encodeURIComponent(this.getUserData.phone)
          : "") +
        (this.getUserData.passport_qr
          ? "&passport_qr=" + encodeURIComponent(this.getUserData.passport_qr)
          : "") +
        (this.getUserData.image
          ? "&image=" + encodeURIComponent(this.getUserData.image)
          : "") +
        (this.getUserData.company_name
          ? "&company_name=" + encodeURIComponent(this.getUserData.company_name)
          : "") +
        "&preRegData=" +
        JSON.stringify(this.$route.query);
      }
    } else if (this.$route.query.add_visitor) {
      if (
        (this.$route.query.email &&
          decodeURIComponent(this.$route.query.email) !=
            this.getUserData.email) ||
        (this.$route.query.phone &&
          decodeURIComponent(this.$route.query.phone) != this.getUserData.phone)
      ) {
        await this.logout({
          email: this.$route.query.email
            ? decodeURIComponent(this.$route.query.email)
            : decodeURIComponent(this.$route.query.phone),
          add_visitor: true,
          visit_url: this.$route.query.visit_url,
          serverUrl: this.$route.query.serverUrl,
        });
        return;
      } else {
        window.location.href =
          this.$route.query.serverUrl +
          `/pre-registration/${this.$route.query.visit_url}?` +
          `add_visitor=${true}&comingFromPassport=${true}` +
          '&first_name=' + encodeURIComponent(this.getUserData.first_name) +
          '&last_name=' + encodeURIComponent(this.getUserData.last_name) +
          (this.getUserData.passport_qr
            ? "&passport_qr=" + encodeURIComponent(this.getUserData.passport_qr)
            : "") +
            (this.getUserData.id
            ? "&passport_id=" + encodeURIComponent(this.getUserData.id)
            : "") +
          (this.getUserData.image
            ? "&image=" + encodeURIComponent(this.getUserData.image)
            : "");
      }
    }

    if (this.$route.query.expectedVisit) this.entrylogsShow = false;
    const { getUserData, getUserQr, userDetails } = this;
    const { atex } = getUserData;
    this.user = getUserData;
    if (this.user.email !== "lt_techteam@visipoint.com") {
      this.fetchUserVisits(this.user.id);
    }
    this.userTimezone = moment.tz.guess();
    this.resetUsername();
    if (getUserData.image !== null) {
      this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${this.getUserData.image}`;
    // } else if (
    //   !getUserData.image &&
    //   this.$route.query &&
    //   this.$route.query.jf_id
    // ) {
    //   this.fetchuserDetails(this.getUserData.id).then(() => {
    //     if (this.getUserData.image) {
    //       this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${this.getUserData.image}`;
    //     }
    //   });
    } else {
      this.fetchuserDetails(this.getUserData.id).then(() => {
        if (this.getUserData.image) {
          this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${this.getUserData.image}`;
        }
      });
    }
    this.getUserIpAction();
    this.fetchUserEntities().then((data) => {
      this.allUserEntities = data.data.data;
    });
    this.getUserProfile().then((data) => {
      // console.log('getUserprof', data);
      if (data.data.sign_in_out_status == "sign_in") this.defaultSignedIn = true;
    });
    // this.fetchAllUserEntities().then(data => {
    //   this.userEntities = data.data.data.filter(item => item.pivot.is_active == 1 && item.package == "Cloud");
    //   this.defaultCompany = data.data.data.find(item => !!item.is_default);
    //   console.log('dffff', this.defaultCompany);
    //   if (this.userEntities.length > 1 && !this.defaultCompany) {
    //     this.firstAttempt = true;
    //     // this.$bvModal.show("changePrimaryCompany");
    //   }
    // });
    if (this.getUserData.email === "lt_techteam@visipoint.com") {
      this.isAdmin = true;
    }
    this.atex = atex;
    this.qr = getUserQr ? getUserQr.replace(/\.[^/.]+$/, "") : null;
    this.systemUser = userDetails?.is_system_user;
  },
  mounted() {
    this.entities = this.getUserEntities;
    if (this.getTmpPwd === 1 && !this.isAdmin) {
      this.$bvModal.show("userPassword");
      this.setData("temporary_password");
    }
    this.$store.watch(
      function(state) {
        return state.user;
      },
      function(data) {
        if (data && data.newImage !== null) {
          this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${data.newImage}`;
        }
      }.bind(this),
      {
        deep: true, //add this if u need to watch object properties change etc.
      }
    );
    if(this.$route.query.force_otp) this.$bvModal.show('twoStepAuthenticationModal');
    if(this.$route.query.onSubscribe) this.fetchUserEntities();

    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload.data);
      if(payload.data && payload.data.entity_id && this.userEntitiesIds.includes(payload.data.entity_id)) {
        this.fetchUserEntities();
      }
    });

  },
};
</script>

<template>
  <Layout>
    <!-- create compant  -->
    <b-modal id="createCompany" scrollable hide-footer hide-header size="md">
      <CreateCompany />
    </b-modal>
    <!-- change profile  -->
    <b-modal id="userProfile" scrollable hide-footer hide-header size="md">
      <ChangeImg />
    </b-modal>
    <!-- update user name  -->
    <b-modal id="userFullName" scrollable hide-footer hide-header size="lg">
      <ChangeName />
    </b-modal>
    <!-- update company name  -->
    <b-modal id="companyName" scrollable hide-footer hide-header size="md">
      <ChangeCompanyName />
    </b-modal>
    <!-- update password  -->
    <b-modal id="userPassword" scrollable hide-footer hide-header size="md">
      <ChangePassword />
    </b-modal>
    <!-- update phone  -->
    <b-modal id="userPhone" scrollable hide-footer hide-header size="md">
      <ChangePhone />
    </b-modal>
    <!-- update email  -->
    <b-modal id="userEmail" scrollable hide-footer hide-header size="md">
      <ChangeEmail />
    </b-modal>

    <!-- check user password -->
    <b-modal id="validateUserPasswordModal" scrollable hide-footer hide-header size="md">
      <validateUserPassword :type="type" />
    </b-modal>
    <!-- deactive account  -->
    <b-modal id="deactiveAccount" scrollable hide-footer hide-header size="md">
      <DeactiveAccount />
    </b-modal>
    <!-- <b-modal id="changePrimaryCompany" scrollable hide-footer hide-header no-close-on-esc no-close-on-backdrop size="lg">
      <ChangePrimaryCompany :userEntities="userEntities" :defaultCompany="defaultCompany" :firstAttempt="firstAttempt"/>
    </b-modal> -->
    <!-- accept invitation  -->
    <b-modal id="acceptInvitation" scrollable hide-footer hide-header size="md">
      <AcceptInvitation />
    </b-modal>
    <!-- reject invitation  -->
    <b-modal id="rejectInvitation" scrollable hide-footer hide-header size="md">
      <RejectInvitation />
    </b-modal>
    <!-- Fill in Compliance & Manage Visit -->
    <b-modal
      id="visit_modal"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      ref="visit_modal"
    >
      <svg
        style="margin-right: 33px; float: right; margin-top: 33px"
        class="close-icon"
        @click="$bvModal.hide('visit_modal')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
      <ComplianceFillIn
        :onlineCompliance="true"
        :visit_url="visit_url"
        :server_url="server_url"
        :firstName="firstName"
        :lastName="lastName"
        :id="userId"
        :entityId="entityId"
        :visitId="visitId"
        :siteName="siteName"
        :areaName="areaName"
        :userTypeForUser="userTypeForUser"
        :visitDate="visitDate"
        :visitTime="visitTime"
        :registrationMethod="registrationMethod"
        :journeyStage="journeyStage"
      />
    </b-modal>

    <b-modal id="twoStepAuthenticationModal" scrollable hide-footer hide-header size="md">
      <TwoStepAuthenticationModal />
    </b-modal>

    <b-modal id="verifyOtpCodeModal" scrollable hide-footer hide-header size="md">
      <VerifyOtpCode :action="'enable_otp'"  :showCloseIcon="true"/>
    </b-modal>

    <b-modal id="OtpAuthAppliedMessageModal" scrollable hide-footer hide-header size="md">
      <OtpAuthAppliedMessage/>
    </b-modal>

    <p class="mobile-view-title">Passport Account</p>
    <!-- non system user view  -->
    <div class="dashboard-wrapper" v-if="(!isAdmin && !systemUser) || allUserEntities.length == 0">
      <div class="dashboard-header">
        <div class="non-system-user-card w-100">
          <div class="settings details-card">
            <div class="dropdown">
              <b-dropdown
                id="dropdown-dropright"
                dropright
                text="Drop-Right"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template #button-content>
                  <i class="mdi mdi-dots-vertical dropdown-icon"></i>
                </template>
                <b-dropdown-item class="dropdown-text" @click="editData = true"
                  >Edit my data</b-dropdown-item
                >
                <b-dropdown-item
                  class="dropdown-text"
                  @click="validationWithPassword('password')"
                  >Change password</b-dropdown-item
                >
                <b-dropdown-item
                class="dropdown-text"
                v-b-modal="'twoStepAuthenticationModal'"
                @click="setData('current_password')"
                >Two step-authentication</b-dropdown-item>
                
                <b-dropdown-item
                  v-b-modal="'deactiveAccount'"
                  class="dropdown-text deactive"
                  href="#"
                >
                  <span class="deactive">Deactivate my account</span>
                </b-dropdown-item>

                <!-- <div class="d-flex align-items-center" :class="{'disabled-div': defaultSignedIn}">
                  <b-dropdown-item
                  v-if="userEntities.length > 1 && defaultCompany"
                  v-b-modal="'changePrimaryCompany'"
                  :disabled="defaultSignedIn"
                  class="dropdown-text primary-item"
                  :class="{'disable-primary-item': defaultSignedIn}"
                  href="#"
                  >
                  <span>Change Primary Company</span>
                  
                  </b-dropdown-item>
                  <template>
                    <svg
                  v-if="defaultSignedIn"
                  tabindex="0"
                  v-b-tooltip
                  :id="'default'"
                  style="margin-left: 10px; outline: none"
                  width="17.73"
                  height="17.73"
                  viewBox="0 0 17.73 17.73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
                    fill="#ACACAC"
                  />
                </svg>

                <b-tooltip
                  v-if="defaultSignedIn"
                  placement="bottomright"
                  :target="'default'"
                  triggers="click blur"
                >
                  {{
                    "You are currently signed in remotely to this company, Kindly sign out out to proceed to update your primary company."
                  }}
                </b-tooltip>
                  </template>
                </div> -->
              </b-dropdown>
            </div>
            <div class="img">
              <b-avatar
                v-if="!imgSpinner"
                :variant="imageToDisplay ? 'light' : 'secondary'"
                class="user-avatar rounded-circle"
                :src="imageToDisplay"
                v-b-modal="editData && 'userProfile'"
                alt="user image"
                :class="!editData && 'no-edit-mode'"
              />
            </div>
            <div class="user-info">
              <div class="name-phone-wrapper w-100">
                <div class="user-name">
                  <label for="name" class="label">Full Name</label>
                  <div class="card-box">
                    <p id="name" class="value">
                      {{
                        this.checkStringLengthWithCapitalize(
                          this.getUserFirstName
                        )
                      }}
                      {{
                        this.checkStringLengthWithCapitalize(
                          this.getUserLastName
                        )
                      }}
                    </p>
                    <i
                      v-if="editData"
                      v-b-modal="'userFullName'"
                      class="mdi mdi-square-edit-outline icon"
                    ></i>
                  </div>
                </div>
                <div class="phone">
                  <label for="phone" class="label">Phone Number</label>
                  <div class="card-box">
                    <p
                      id="phone"
                      :class="getUserPhone ? 'value' : 'value text-muted'"
                    >
                      {{
                        getUserPhone ? `+${getUserPhone}` : "-"
                      }}
                    </p>
                    <i
                      v-if="editData" @click="validationWithPassword('phone')"
                      class="mdi mdi-square-edit-outline icon"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="company-email-wrapper w-100">
                <div class="email">
                  <label for="email" class="label">Email</label>
                  <div class="card-box">
                    <p id="email" class="value">
                      {{ getUserEmail ? getUserEmail : '-' }}
                    </p>
                    <i
                      v-if="editData" @click="validationWithPassword('email')"
                      class="mdi mdi-square-edit-outline icon"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn-wrapper">
              <button
                v-if="editData"
                @click="editData = false"
                class="btn btn-primary"
              >
                Done
              </button>
            </div>
          </div>
          <div v-if="qr" class="qr-wrapper details-card">
            <div class="qr">
              <p class="qr-title">My QuickPass</p>
              <vue-qrcode
                class="qr-code"
                :value="`${qr}.png`"
                :options="{
                  width: 125,
                  color: { dark: '#000' },
                }"
              ></vue-qrcode>
              <a
                class="download-text"
                target="_blank"
                :href="`${qr.replace('images', 'pdf')}.pdf`"
                >Download as PDF</a
              >
            </div>
            <div class="mobile-actions">
              <a href="#" class="apple-wallet mx-auto">
                <img
                  src="@/assets/images/passport/apple-wallet.svg"
                  class="unselectable"
                  alt="apple-wallet"
                />
              </a>
              <a href="#" class="mx-auto">
                <img
                  src="@/assets/images/passport/g-pay.svg"
                  class="unselectable"
                  alt="apple-wallet"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isAdmin" class="visit-container">
        <b-button
          class="btn btn-sm mr-2 ml-4 mb-4 btn-visits"
          :class="{ 'inactive-tab': !entrylogsShow }"
          @click="showEntrylogs(true)"
        >
          My Entry Logs
        </b-button>
        <b-button
          class="btn btn-sm mr-2 ml-3 mb-4 btn-visits"
          :class="{ 'inactive-tab': entrylogsShow }"
          @click="showEntrylogs(false)"
        >
          Expected Visits
        </b-button>
        <div v-if="entrylogsShow" class="entry-logs">
          <DxDataGrid
          v-if="getUserVisits && getUserVisits.entry_logs"
            :ref="dataGridRefKey"
            @editor-preparing="overrideOnValueChanged"
            noDataText="No Logs yet"
            key-expr="id"
            :data-source="getUserVisits.entry_logs"
            :remote-operations="false"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :rowAlternationEnabled="false"
            :columnHidingEnabled="true"
            :show-borders="true"
            :show-row-lines="true"
            :show-column-lines="true"
            :two-way-binding-enabled="true"
          >
            <DxColumn
              data-field="scan_data_type.name"
              data-type="string"
              caption="Status"
              cell-template="status-cell"
              :allow-filtering="false"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-field="entity_name"
              data-type="string"
              caption="Company"
              :allow-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="site_name"
              data-type="string"
              caption="Site"
              :allow-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-type="string"
              caption="User Type"
              :allow-filtering="true"
              :calculate-cell-value="getUserTypeName"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="signed_in"
              caption="Arrival Time"
              :calculate-cell-value="getArrivalTime"
              :allow-filtering="false"
            />
            <DxColumn
              data-field="signed_out"
              caption="Departure Time"
              :calculate-cell-value="getDepartureTime"
              :allow-filtering="false"
            />
            <DxPager
              :allowed-page-sizes="pageSizes"
              :display-mode="'full'"
              :visible="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />

            <template #status-cell="{ data }">
              <div
                v-if="
                  data.data.scan_data_type_id == 5 ||
                    data.data.scan_data_type_id == 4 ||
                    data.data.scan_data_type_id == 8
                "
              >
                <span class="text-red font-weight-bold">
                  {{ data.data.scan_data_type_name ?  data.data.scan_data_type_name  : ''}}
                </span>
              </div>
              <div v-else class="text-green font-weight-bold">
                {{ data.data.scan_data_type_name ? data.data.scan_data_type_name : '' }}
              </div>
            </template>
          </DxDataGrid>

          <div v-else class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>

        <div v-if="!entrylogsShow" class="expected-visits">
          <DxDataGrid
          v-if="getUserVisits && getUserVisits.expected_scans"
            :ref="dataGridRefKey2"
            @editor-preparing="overrideOnValueChanged"
            noDataText="No expected visits yet"
            key-expr="id"
            :data-source="getUserVisits.expected_scans"
            :remote-operations="false"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :rowAlternationEnabled="false"
            :columnHidingEnabled="true"
            :show-borders="true"
            :show-row-lines="true"
            :show-column-lines="true"
            :two-way-binding-enabled="true"
          >
            <DxColumn
              caption="Compliance"
              :allow-filtering="false"
              :allow-header-filtering="false"
              :visible="true"
              
              cell-template="compliance-cell"
            />
            <DxColumn
              data-field="status"
              data-type="string"
              caption="Status"
              cell-template="status-cell"
              :allow-filtering="true"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-field="company"
              data-type="string"
              caption="Company"
              :allow-filtering="true"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="site"
              data-type="string"
              caption="Site"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="area"
              data-type="string"
              caption="Area"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="host"
              data-type="string"
              caption="Host"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :calculate-cell-value="getHost"
            />
            <DxColumn
              data-field="scan_user_type"
              data-type="string"
              caption="User Type"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-type="string"
              caption="Input Type"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
              :calculate-cell-value="getInputType"
            />
            <DxColumn
              data-field="expected_visit_time"
              caption="Expected At"
              :calculate-cell-value="getExpectedTime"
              :allow-filtering="false"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-type="string"
              caption="Journey Stage"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
              :calculate-cell-value="getJourneyStage"
            />
            <DxColumn
              caption="Visit Invitation"
              :allow-filtering="false"
              :allow-header-filtering="false"
              cell-template="visit-cell"
            />
            <DxPager
              :allowed-page-sizes="pageSizes2"
              :display-mode="'full'"
              :visible="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />

            <template #status-cell="{ data }">
              <div v-if="data.data.data_type_id == 6">
                <span style="color: #ffa500" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
                <svg
                  v-if="
                    data.data.action_by && data.data.action_by.type == 'Admin'
                  "
                  tabindex="0"
                  v-b-tooltip
                  :id="data.data.id"
                  style="margin-left: 10px; outline: none"
                  width="17.73"
                  height="17.73"
                  viewBox="0 0 17.73 17.73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
                    fill="#ACACAC"
                  />
                </svg>

                <b-tooltip
                  v-if="
                    data.data.action_by && data.data.action_by.type == 'Admin'
                  "
                  placement="bottomright"
                  :target="data.data.id"
                  triggers="click blur"
                >
                  {{
                    data.data && data.data.action_by
                      ? `You're invited by admin (${data.data.action_by.fullName}).`
                      : ""
                  }}
                </b-tooltip>
              </div>
              <div v-else-if="data.data.data_type_id == 15" style="color: red">
                <span style="color: #f46a6a" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
              </div>
              <div v-else-if="data.data.data_type_id == 12" style="color: red">
                <span style="color: #f46a6a" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
              </div>
              <div v-else-if="data.data.data_type_id == 7">
                <span style="color: #000000" class="font-weight-bold"
                  >{{ data.data.status }}
                </span>
              </div>
              <div v-else style="color: #000000" class="font-weight-bold">
                {{ data.data.status }}
              </div>
            </template>

            <template #compliance-cell="{ data }">
              <div
                class="confirm-visit-btn"
                v-if="
                  data.data.data_type_id == 6 &&
                    data.data.action_by &&
                    data.data.package == 'Cloud' &&
                    data.data.has_compliances
                "
              >
                <span
                  :id="data.data.id + 'view'"
                  class="d-inline-block"
                  tabindex="0"
                >
                  <b-button
                    variant="primary"
                    type="submit"
                    pill
                    @click="viewCompliance(data.data)"
                    class="view-btnn"
                    :disabled="
                      data.data.metadata
                      && !JSON.parse(data.data.metadata.is_confirmed)
                      && data.data.action_by
                      && data.data.action_by.type == 'Admin'
                    "
                  >
                    View</b-button
                  >
                </span>

                <b-tooltip
                  v-if="
                    data.data.metadata &&
                      !JSON.parse(data.data.metadata.is_confirmed)
                  "
                  placement="bottomright"
                  :target="data.data.id + 'view'"
                >
                  Please confirm the invitation first to be able to access the
                  compliance.
                </b-tooltip>
              </div>
              <div class="btn-wrapper-view" v-else>-</div>
            </template>

            <template #visit-cell="{ data }">
              <div
                class="confirm-visit-btn"
                v-if="
                  data.data.data_type_id == 6 &&
                  data.data.action_by &&
                  data.data.action_by.type == 'Admin' &&
                  data.data.metadata &&
                  !JSON.parse(data.data.metadata.is_confirmed)
                "
              >
                <b-button
                  variant="primary"
                  type="submit"
                  pill
                  @click="confirmVisit(data.data)"
                  class="confirm-btnn"
                >
                  Confirm</b-button
                >
              </div>
              <div
                class="btn-wrapper"
                v-else-if="
                  data.data.data_type_id == 6 &&
                  data.data.action_by &&
                  data.data.action_by.type == 'Admin' &&
                  data.data.metadata &&
                  JSON.parse(data.data.metadata.is_confirmed)
                "
              >
                <span
                  style="margin-left: 15px"
                  class="text-green font-weight-bold">
                  Confirmed
                </span>
              </div>
              <div class="btn-wrapper sub-table" v-else>-</div>
            </template>
          </DxDataGrid>

          <div v-else class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- system user view  -->
    <section class="dashboard-wrapper" v-else>
      <div class="dashboard-header">
        <div class="user-card details-card" v-if="!isAdmin">
          <div class="settings">
            <div class="dropdown">
              <b-dropdown
                id="dropdown-dropright"
                dropright
                text="Drop-Right"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template #button-content>
                  <i class="mdi mdi-dots-vertical dropdown-icon"></i>
                </template>
                <b-dropdown-item class="dropdown-text" @click="editData = true"
                  >Edit my data</b-dropdown-item
                >
                <b-dropdown-item
                  class="dropdown-text"
                  @click="validationWithPassword('password')"
                  >Change password</b-dropdown-item
                >
                <b-dropdown-item
                class="dropdown-text"
                v-b-modal="'twoStepAuthenticationModal'"
                @click="setData('current_password')"
                >Two step-authentication</b-dropdown-item>
                <b-dropdown-item
                  v-b-modal="'deactiveAccount'"
                  class="dropdown-text deactive"
                >
                  <span class="deactive">Deactivate my account</span>
                </b-dropdown-item>

                <!-- <div class="d-flex align-items-center" :class="{'disabled-div': defaultSignedIn}">
                  <b-dropdown-item
                  v-if="userEntities.length > 1 && defaultCompany"
                  v-b-modal="'changePrimaryCompany'"
                  :disabled="defaultSignedIn"
                  class="dropdown-text primary-item"
                  :class="{'disable-primary-item': defaultSignedIn}"
                  href="#"
                  >
                  <span>Change Primary Company</span>
                  
                  </b-dropdown-item>
                  <template>
                    <svg
                  v-if="defaultSignedIn"
                  tabindex="0"
                  v-b-tooltip
                  :id="'default'"
                  style="margin-left: 10px; outline: none"
                  width="17.73"
                  height="17.73"
                  viewBox="0 0 17.73 17.73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
                    fill="#ACACAC"
                  />
                </svg>

                <b-tooltip
                  v-if="defaultSignedIn"
                  placement="bottomright"
                  :target="'default'"
                  triggers="click blur"
                >
                  {{
                    "You are currently signed in remotely to this company, Kindly sign out out to proceed to update your primary company."
                  }}
                </b-tooltip>
                  </template>
                </div> -->
                
              </b-dropdown>
            </div>
            <div class="qr-img-wrapper">
              <div class="img">
                <b-avatar
                  v-if="!imgSpinner"
                  :variant="imageToDisplay ? 'light' : 'secondary'"
                  class="user-avatar rounded-circle"
                  :src="imageToDisplay"
                  v-b-modal="editData && 'userProfile'"
                  alt="user image"
                  :class="!editData && 'no-edit-mode'"
                />
                <button
                  v-if="editData"
                  @click="editData = false"
                  class="btn btn-primary"
                >
                  Done
                </button>
              </div>
              <div v-if="qr" class="qr">
                <p class="qr-title">My QuickPass</p>
                <vue-qrcode
                  class="qr-code"
                  :value="`${qr}.png`"
                  :options="{
                    width: 125,
                    color: { dark: '#000' },
                  }"
                ></vue-qrcode>
                <a
                  class="download-text"
                  target="_blank"
                  :href="`${qr.replace('images', 'pdf')}.pdf`"
                  >Download as PDF</a
                >
              </div>
            </div>
          </div>
          <hr class="h-line d-none d-md-block" />
          <div class="info">
            <div class="name-phone-wrapper w-100">
              <div class="user-name">
                <label for="name" class="label">Full Name</label>
                <div class="card-box">
                  <p id="name" class="value">
                    {{
                      this.checkStringLengthWithCapitalize(
                        this.getUserFirstName
                      )
                    }}
                    {{
                      this.checkStringLengthWithCapitalize(this.getUserLastName)
                    }}
                  </p>
                  <i
                    v-if="editData"
                    v-b-modal="'userFullName'"
                    class="mdi mdi-square-edit-outline icon"
                  ></i>
                </div>
              </div>
              <div class="phone">
                <label for="phone" class="label">Phone Number</label>
                <div class="card-box">
                  <p
                    id="phone"
                    :class="getUserPhone ? 'value' : 'value text-muted'"
                  >
                    {{ getUserPhone ? `+${getUserPhone}` : "-" }}
                  </p>
                  <i
                    v-if="editData" @click="validationWithPassword('phone')"                   
                    class="mdi mdi-square-edit-outline icon"
                  ></i>
                </div>
              </div>
            </div>
            <div class="company-email-wrapper w-100">
              <div class="email">
                <label for="email" class="label">Email</label>
                <div class="card-box">
                  <p id="email" class="value">
                    {{ getUserEmail ? getUserEmail : '-' }}
                  </p>
                  <i
                    v-if="editData" @click="validationWithPassword('email')"
                    class="mdi mdi-square-edit-outline icon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- mobile tablet qr  -->
        <div v-if="!isAdmin" class="qr-mobile-view details-card">
          <div v-if="qr" class="qr">
            <p class="qr-title">My QuickPass</p>
            <vue-qrcode
              class="qr-code"
              :value="`${qr}.png`"
              :options="{
                width: 125,
                color: { dark: '#000' },
              }"
            ></vue-qrcode>
            <a
              class="download-text"
              target="_blank"
              :href="`${qr.replace('images', 'pdf')}.pdf`"
              >Download as PDF</a
            >
          </div>
        </div>

        <div
          :class="
            isAdmin
              ? 'w-100 companies-card-admin details-card'
              : 'companies-card details-card'
          "
        >
          <div>
            <div class="header">
              <div class="title-wrapper">
                <p class="title">My Companies</p>
                <i
                  v-if="!isAdmin"
                  v-b-modal="'createCompany'"
                  class="mdi mdi-plus-circle add-icon"
                ></i>
              </div>
              <form
                v-if="
                  getUserEntities.length > 10 ||
                    searchName.length > 0 ||
                    isAdmin
                "
                class="app-search search-wrapper w-50"
              >
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control search-input"
                    placeholder="Search comapny"
                    v-model="searchName"
                    @keyup="searchByName"
                  />
                  <span class="bx bx-search search-icon"></span>
                </div>
              </form>
            </div>
            <!-- tech team view  -->
            <div v-if="isAdmin">
              <div v-if="getUserEntities.length > 0" class="entities-list">
                <div
                  class="entity-item"
                  v-for="entity of getUserEntities"
                  :key="entity.id"
                  @click="getBtnText(entity) == 'Go' ? getBtnUrl(entity) : ''"
                  :style="getBtnText(entity) == 'Go' ? 'cursor: pointer' : ''"
                >
                  <p class="entity" :class="isAdmin && 'entity-width'">
                    <span class="mr-1">{{ sliceLongString(entity.name) }}</span>
                    at
                    <a class="text-primary ml-1">{{
                      entity.server.server_url
                    }}</a>
                  </p>
                  <p v-if="isAdmin" class="entity-package mb-0">
                    {{ entity.package }}
                  </p>
                  <div class="actions" v-if="entity.pivot.status == 2">
                    <b-button
                      @click="setUserData(entity)"
                      v-b-modal="'acceptInvitation'"
                      class="btn btn-success btn-sm accept"
                    >
                      Accept
                    </b-button>
                    <b-button
                      @click="setUserData(entity)"
                      v-b-modal="'rejectInvitation'"
                      class="btn btn-outline-danger btn-sm reject"
                    >
                      Reject
                    </b-button>
                  </div>
                  <div class="actions" v-else>
                    <a
                      :href="getBtnUrl(entity)"
                      :class="[getBtnClass(entity), isAdmin ? 'adminBtn' : '']"
                      v-if="getBtnText(entity) == 'Go'"
                    >
                      <i class="mdi mdi-chevron-right go-icon"></i>
                    </a>
                    <a
                      v-else
                      :href="getBtnUrl(entity)"
                      class="text-danger"
                      :class="[getBtnClass(entity), isAdmin ? 'adminBtn' : '']"
                    >
                      {{ getBtnText(entity) }}
                    </a>
                  </div>
                </div>
              </div>
              <p class="no-data-text" v-else>No Companies yet</p>
              <div class="pagination">
                <div
                  class="overflow-auto mx-auto"
                  style="padding: 0 10px"
                  v-if="isAdmin"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="this.getTotalRows"
                    :per-page="this.getPerPage"
                    aria-controls="my-table"
                    @change="getPaginatedEntities"
                  ></b-pagination>
                </div>
              </div>
            </div>
            <!-- user view  -->
            <div v-else>
              <div v-if="getUserEntities.length > 0" class="entities-list">
                <!-- invitations companies  -->
                <p v-if="usersInvitations.length > 0" class="sub-title">
                  Invitations
                </p>
                <div
                  class="entity-item invitation-item"
                  v-for="entity of usersInvitations"
                  :key="entity.id"
                >
                  <p
                    v-if="entity.pivot.status == 2"
                    class="entity invitation-entity"
                    :class="isAdmin && 'entity-width'"
                  >
                    {{ entity.name }} at {{ entity.server.server_url }}
                  </p>
                  <div class="actions">
                    <b-button
                      @click="setUserData(entity)"
                      v-b-modal="'acceptInvitation'"
                      class="btn btn-success btn-sm accept"
                    >
                      Accept
                    </b-button>
                    <b-button
                      @click="setUserData(entity)"
                      v-b-modal="'rejectInvitation'"
                      class="btn btn-outline-danger btn-sm reject"
                    >
                      Reject
                    </b-button>
                  </div>
                </div>
                <hr
                  v-if="usersInvitations.length > 0"
                  class="entities-line h-line"
                />
                <!-- others  -->
                <div
                  class="entity-item"
                  v-for="entity of normalEntities"
                  :key="entity.id"
                  @click="onEntityRedirect(entity)"
                  style="cursor: pointer"
                >
                  <p class="entity" :class="isAdmin && 'entity-width'">
                    {{ sliceLongString(entity.name) }} at
                    {{ entity.server.server_url }}
                  </p>
                  <p v-if="isAdmin" class="entity-package">
                    {{ entity.package }}
                  </p>
                  <div class="actions" v-else>
                    <a
                      @click="onEntityRedirect(entity)"
                      :class="[getBtnClass(entity), isAdmin ? 'adminBtn' : '']"
                      v-if="getBtnText(entity) == 'Go'"
                    >
                      <i class="mdi mdi-chevron-right go-icon"></i>
                    </a>
                    <a
                      v-else
                      @click="onEntityRedirect(entity)"
                      class="text-danger"
                      :class="[getBtnClass(entity), isAdmin ? 'adminBtn' : '']"
                    >
                      {{ getBtnText(entity) }}
                    </a>
                  </div>
                </div>
              </div>
              <p class="no-data-text" v-else>No Companies yet</p>
              <div class="pagination">
                <div
                  class="overflow-auto mx-auto"
                  style="padding: 0 10px"
                  v-if="isAdmin"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="this.getTotalRows"
                    :per-page="this.getPerPage"
                    aria-controls="my-table"
                    @change="getPaginatedEntities"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isAdmin" class="visit-container">
        <div class="grid-btns">
        <b-button
          class="btn btn-sm mr-2 ml-4 mb-4 btn-visits"
          :class="{ 'inactive-tab': !entrylogsShow }"
          @click="showEntrylogs(true)"
        >
          My Entry Logs
        </b-button>
        <b-button
          class="btn btn-sm mr-2 ml-3 mb-4 btn-visits"
          :class="{ 'inactive-tab': entrylogsShow }"
          @click="showEntrylogs(false)"
        >
          Expected Visits
        </b-button>
      </div>
        <div v-if="entrylogsShow" class="entry-logs">
          <DxDataGrid
          v-if="getUserVisits && getUserVisits.entry_logs"
            :ref="dataGridRefKey"
            @editor-preparing="overrideOnValueChanged"
            noDataText="No Logs yet"
            key-expr="id"
            :data-source="getUserVisits.entry_logs"
            :remote-operations="false"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :rowAlternationEnabled="false"
            :columnHidingEnabled="true"
            :show-borders="true"
            :show-row-lines="true"
            :show-column-lines="true"
            :two-way-binding-enabled="true"
          >
            <DxColumn
              data-field="scan_data_type_name"
              data-type="string"
              caption="Status"
              cell-template="status-cell"
              :allow-filtering="true"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-field="entity_name"
              data-type="string"
              caption="Company"
              :allow-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="site_name"
              data-type="string"
              caption="Site"
              :allow-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-type="string"
              caption="User Type"
              :allow-filtering="true"
              :calculate-cell-value="getUserTypeName"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="signed_in"
              caption="Arrival Time"
              :calculate-cell-value="getArrivalTime"
              :allow-filtering="false"
            />
            <DxColumn
              data-field="signed_out"
              caption="Departure Time"
              :calculate-cell-value="getDepartureTime"
              :allow-filtering="false"
            />
            <DxPager
              :allowed-page-sizes="pageSizes"
              :display-mode="'full'"
              :visible="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />

            <template #status-cell="{ data }">
              <div
                v-if="
                  data.data.scan_data_type_id == 5 ||
                    data.data.scan_data_type_id == 4 ||
                    data.data.scan_data_type_id == 8
                "
              >
                <span class="text-red font-weight-bold">
                  {{ data.data.scan_data_type_name ? data.data.scan_data_type_name : '' }}
                </span>
              </div>
              <div v-else class="text-green font-weight-bold">
                {{ data.data.scan_data_type_name  ? data.data.scan_data_type_name : '' }}
              </div>
            </template>
          </DxDataGrid>

          <div v-else class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>

        <div v-if="!entrylogsShow" class="expected-visits">
          <DxDataGrid
          v-if="getUserVisits && getUserVisits.expected_scans"
            :ref="dataGridRefKey2"
            @editor-preparing="overrideOnValueChanged"
            noDataText="No expected visits yet"
            key-expr="id"
            :data-source="getUserVisits.expected_scans"
            :remote-operations="false"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :rowAlternationEnabled="false"
            :columnHidingEnabled="true"
            :show-borders="true"
            :show-row-lines="true"
            :show-column-lines="true"
            :two-way-binding-enabled="true"
          >
            <DxColumn
              caption="Compliance"
              :allow-filtering="false"
              :allow-header-filtering="false"
              :visible="true"
              alignment="center"
              cell-template="compliance-cell"
            />
            <DxColumn
              data-field="status"
              data-type="string"
              caption="Status"
              cell-template="status-cell"
              :allow-filtering="true"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-field="company"
              data-type="string"
              caption="Company"
              :allow-filtering="true"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="site"
              data-type="string"
              caption="Site"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="area"
              data-type="string"
              caption="Area"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-field="host"
              data-type="string"
              caption="Host"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :calculate-cell-value="getHost"
            />
            <DxColumn
              data-field="scan_user_type"
              data-type="string"
              caption="User Type"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
            />
            <DxColumn
              data-type="string"
              caption="Input Type"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
              :calculate-cell-value="getInputType"
            />
            <DxColumn
              data-field="expected_visit_time"
              caption="Expected At"
              :calculate-cell-value="getExpectedTime"
              :allow-filtering="false"
              :allow-header-filtering="true"
            />
            <DxColumn
              data-type="string"
              caption="Journey Stage"
              :allow-filtering="false"
              :allow-header-filtering="true"
              :filter-operations="allowedOperations"
              :calculate-cell-value="getJourneyStage"
            />
            <DxColumn
              caption="Visit Invitation"
              :allow-filtering="false"
              :allow-header-filtering="false"
              cell-template="visit-cell"
            />
            <DxPager
              :allowed-page-sizes="pageSizes2"
              :display-mode="'full'"
              :visible="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />

            <template #compliance-cell="{ data }">
              <div
                class="confirm-visit-btn"
                v-if="
                  data.data.data_type_id == 6 &&
                    data.data.action_by &&
                    data.data.package == 'Cloud' &&
                    data.data.has_compliances
                "
              >
                <span
                  :id="data.data.id + 'view'"
                  class="d-inline-block"
                  tabindex="0"
                >
                  <b-button
                    variant="primary"
                    type="submit"
                    pill
                    @click="viewCompliance(data.data)"
                    class="view-btnn"
                    :disabled="
                      data.data.metadata
                      && !JSON.parse(data.data.metadata.is_confirmed)
                      && data.data.action_by
                      && data.data.action_by.type == 'Admin'
                    "
                  >
                    View</b-button
                  >
                </span>

                <b-tooltip
                  v-if="
                    data.data.metadata &&
                      !JSON.parse(data.data.metadata.is_confirmed)
                  "
                  placement="bottomright"
                  :target="data.data.id + 'view'"
                >
                  Please confirm the invitation first to be able to access the
                  compliance.
                </b-tooltip>
              </div>
              <div class="btn-wrapper-view" v-else>-</div>
            </template>

            <template #status-cell="{ data }">
              <div v-if="data.data.data_type_id == 6">
                <span style="color: #ffa500" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
                <svg
                  v-if="
                    data.data.action_by && data.data.action_by.type == 'Admin'
                  "
                  tabindex="0"
                  v-b-tooltip
                  :id="data.data.id"
                  style="margin-left: 10px; outline: none"
                  width="17.73"
                  height="17.73"
                  viewBox="0 0 17.73 17.73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
                    fill="#ACACAC"
                  />
                </svg>

                <b-tooltip
                  v-if="
                    data.data.action_by && data.data.action_by.type == 'Admin'
                  "
                  placement="bottomright"
                  :target="data.data.id"
                  triggers="click blur"
                >
                  {{
                    data.data && data.data.action_by
                      ? `You're invited by admin (${data.data.action_by.fullName}).`
                      : ""
                  }}
                </b-tooltip>
              </div>
              <div v-else-if="data.data.data_type_id == 15" style="color: red">
                <span style="color: #f46a6a" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
              </div>
              <div v-else-if="data.data.data_type_id == 12" style="color: red">
                <span style="color: #f46a6a" class="font-weight-bold">
                  {{ data.data.status }}
                </span>
              </div>
              <div v-else-if="data.data.data_type_id == 7">
                <span style="color: #000000" class="font-weight-bold">{{
                  data.data.status
                }}</span>
              </div>
              <div v-else style="color: #000000" class="font-weight-bold">
                {{ data.data.status }}
              </div>
            </template>

            <template #visit-cell="{ data }">
              <div
                class="confirm-visit-btn"
                v-if="
                  data.data.data_type_id == 6 &&
                    data.data.action_by &&
                    data.data.action_by.type == 'Admin' &&
                    data.data.metadata &&
                    !JSON.parse(data.data.metadata.is_confirmed)
                "
              >
                <b-button
                  variant="primary"
                  type="submit"
                  pill
                  @click="confirmVisit(data.data)"
                  class="confirm-btnn"
                >
                  Confirm</b-button
                >
              </div>
              <div
                class="btn-wrapper"
                v-else-if="
                  data.data.data_type_id == 6 &&
                  data.data.action_by &&
                  data.data.action_by.type == 'Admin' &&
                  data.data.metadata &&
                  JSON.parse(data.data.metadata.is_confirmed)
                "
              >
                <span
                  style="margin-left: 15px"
                  class="text-green font-weight-bold">
                  Confirmed
                </span>
              </div>
              <div class="btn-wrapper sub-table" v-else>-</div>
            </template>
          </DxDataGrid>

          <div v-else class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss">
li.dropdown-text.disable-primary-item {
  pointer-events: none !important;
}
a.dropdown-item.disabled {
  padding-right: unset !important;
}
.disabled-div {
  padding-right: 3rem !important;
}
@media(max-width:992px){
  .visit-container{
    padding-top: 26px!important;
    padding-top:26px!important;
    padding-left: 0px!important;
  }
  .grid-btns{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    .btn-visits{
      font-size: 14px!important;
      width: 125px!important;
    }
  }
}
.sub-table{
  margin-left: 20px;
}
.disable-view {
  opacity: 0.6;
  cursor: not-allowed !important;
  // pointer-events: none;
}
// .confirm-visit-btn.dx-template-wrapper{
//   display: flex;
//     justify-content: center;
// }
.btn-wrapper-view.dx-template-wrapper{
  display: flex;
    align-items: center;
    justify-content: center;
}
button.btn.view-btnn.btn-primary.rounded-pill {
  width: 70px;
  height: 25px;
  background: #103f5e;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12.5px !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-left: 15px;
  color: #ffffff;
}
button.btn.confirm-btnn.btn-primary.rounded-pill{
  width: 88px;
height: 27px;
font-family: 'Lato';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 19px;
text-align: center;
display: flex;
margin-left: 15px;
  justify-content: center;
  align-items: center;
color: #FFFFFF;
background: #103F5E;
border-radius: 43px!important;
}
.dx-pager .dx-page-sizes .dx-selection,
.dx-pager .dx-pages .dx-selection {
  font-weight: 500;
  background-color: #103f5e;
  color: #fff;
}

dx-button-mode-text.dx-button-default {
  background-color: transparent;
  color: #103f5e;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dx-checkbox-checked .dx-checkbox-icon {
  color: #fff;
  background-color: #103f5e;
  border: none;
  font: 16px/1em DXIcons;
  text-align: center;
}
.dx-checkbox-indeterminate .dx-checkbox-icon {
  background-color: #103f5e;
  color: #fff;
  border: none;
  font: 20px/1em DXIcons;
  text-align: center;
}

.tooltip .tooltip-inner {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161);
  color: #787878;
  width: 137px;
}
.tooltip .arrow {
  display: none !important;
}

.dx-placeholder {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #939393;
}
.dx-master-detail-cell {
  background-color: #f3f3f3 !important;
}
.dx-button-mode-text.dx-button-default {
  background-color: transparent;
  color: #103f5e;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dx-datagrid-filter-row {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>

::v-deep{
  @media(max-width:992px){
    .dx-field-item-content.dx-field-item-content-location-bottom.dx-adaptive-item-text {
    white-space: normal;
    line-height: 20px;
}
}
}

.mobile-view-title {
  display: none;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #000000;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: block;
  }
}
.dashboard-wrapper {
  background: #f3f3f3;
  .dashboard-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    // non system user
    .non-system-user-card {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .settings {
        display: flex;
        align-items: center;
        width: 80.5%;
        .dropdown {
          margin-right: 36px;
          .dropdown-icon {
            color: #787878;
            font-size: 1.6rem;
          }
          .dropdown-text {
            text-align: center;
            font-size: 16px;
            color: #787878;
            font-weight: 400;
            font-family: 'Lato';
            .deactive {
              color: #f46a6a;
              margin: 0;
              padding: 0;
              font-weight: normal;
            }
          }
        }
        .img {
          display: flex;
          flex-direction: column;
          margin-right: 78px;
          .user-avatar {
            width: 106px;
            height: 106px;
            margin-bottom: 20px;
          }
          .no-edit-mode {
            cursor: context-menu;
          }
        }
        .user-info {
          display: flex;
          justify-content: space-between;
          margin-right: 124px;
          width: 40%;
          .label {
            color: #c7c7c7;
            font-size: 14px;
            margin-bottom: 7px;
            font-weight: 600;
          }
          .card-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .value {
              font-size: 16px;
              color: #495057;
              margin-inline: 0;
              font-weight: normal;
              margin-bottom: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 15em;
            }
            .icon {
              color: #787878;
              font-size: 1.4rem;
              font-weight: bold;
              cursor: pointer;
            }
          }
          .user-name,
          .phone {
            padding-right: 60px;
          }
          .user-name,
          .company-name {
            margin-bottom: 37px;
          }
          .company-email-wrapper {
            position: relative;
            padding-left: 37px;
            &::before {
              content: "";
              width: 0;
              height: 100px;
              position: absolute;
              opacity: 0.08;
              border: 0.5px solid #000000;
              background-color: #000;
              top: 25px;
              left: 0;
            }
          }
        }
        .btn-wrapper {
          width: 111.7px;
          .btn {
            width: 100%;
            border-radius: 16.6275px;
            height: 33.26px;
          }
        }
      }
      .qr-wrapper {
        display: flex;
        justify-content: center;
        width: 18%;
        .qr {
          background-color: #f3f3f3;
          padding: 15px 30px;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          .qr-title {
            color: #c7c7c7;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .qr-code {
            margin: 0 auto;
            margin-bottom: 10px;
            border-radius: 12px;
            width: 100%;
          }
          .download-text {
            color: #000;
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            text-align: center;
          }
        }
      }
      .mobile-actions {
        display: none;
      }
    }
    // user
    .user-card {
      .settings {
        display: flex;
        align-items: flex-start;
        .qr-img-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          .img {
            display: flex;
            flex-direction: column;
            margin: 0 auto;
            .user-avatar {
              width: 106px;
              height: 106px;
              margin-bottom: 20px;
            }
            .no-edit-mode {
              cursor: context-menu;
            }
            .btn {
              padding: 0;
              border-radius: 16.6275px;
              height: 33.26px;
            }
          }
          .qr {
            background-color: #f3f3f3;
            padding: 15px 30px;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            .qr-title {
              color: #c7c7c7;
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .qr-code {
              margin: 0 auto;
              margin-bottom: 10px;
            }
            .download-text {
              color: #000;
              text-align: center;
              font-weight: bold;
              font-size: 14px;
              text-align: center;
            }
          }
        }
        .dropdown-icon {
          color: #787878;
          font-size: 1.6rem;
        }
        .dropdown-text {
          text-align: center;
          font-size: 16px;
          color: #787878;
          font-weight: 400;
          font-family: 'Lato';
          .deactive {
            color: #f46a6a;
            margin: 0;
            padding: 0;
            font-weight: normal;
          }
        }
      }
      .h-line {
        margin-top: 1.8rem;
        opacity: 0.08;
        border-top: 1px solid #000000;
      }
      .info {
        display: flex;
        justify-content: space-between;
        padding-left: 30px;
        .label {
          color: #c7c7c7;
          font-size: 14px;
          margin-bottom: 7px;
          font-weight: 600;
        }
        .card-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .value {
            font-size: 16px;
            color: #495057;
            margin-inline: 0;
            font-weight: normal;
            margin-bottom: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 15em;
          }
          .icon {
            color: #787878;
            font-size: 1.4rem;
            font-weight: bold;
            cursor: pointer;
          }
        }
        .user-name,
        .phone {
          padding-right: 50px;
        }
        .user-name,
        .company-name {
          margin-bottom: 37px;
        }
        .company-email-wrapper {
          position: relative;
          padding-left: 37px;
          &::before {
            content: "";
            width: 0;
            height: 100px;
            position: absolute;
            opacity: 0.08;
            border: 0.5px solid #000000;
            background-color: #000;
            top: 25px;
            left: 0;
          }
        }
      }
    }
    // company
    .companies-card {
      height: 454px;
      overflow-y: scroll;
      .header,
      .title-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .header {
        padding-left: 13px;
        margin-bottom: 18px;
        .title {
          margin-bottom: 0;
          font-size: 16px;
          color: #495057;
          font-weight: normal;
          margin-right: 14px;
        }
        .add-icon {
          color: #103f5e;
          font-size: 1.9rem;
          cursor: pointer;
        }
        .search-wrapper {
          input {
            background-color: #f2f2f2;
            padding-left: 55px;
          }
          .search-icon {
            left: 26px;
            top: 1px;
          }
        }
      }
      .sub-title {
        margin-bottom: 16px;
        color: #c7c7c7;
        font-size: 14px;
        font-weight: 500;
        padding-left: 13px;
      }
      .entities-list {
        .entities-line {
          margin: 24px 0;
        }
        .entity-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f7f7f7;
          padding: 20px;
          margin-left: -3px;
          border-radius: 5px;
          margin-bottom: 15px;
          .entity {
            margin-bottom: 0;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;
            color: #495057;
          }
          .actions {
            display: flex;
            .accept {
              margin-right: 17px;
            }
            .reject {
              background-color: transparent;
              &:hover,
              &:focus {
                background-color: #f46a6a;
                color: #fff !important;
                border-color: #f46a6a !important;
              }
            }
            .accept,
            .reject {
              width: 68px;
              font-size: 16px;
            }
            .go-icon {
              font-size: 1.7rem;
              color: #495057;
            }
          }
        }
      }
      .no-data-text {
        font-size: 16px;
        text-align: center;
        margin-top: 50px;
        color: #939393;
      }
    }
    // company admin
    .companies-card-admin {
      .header,
      .title-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .header {
        padding-left: 13px;
        margin-bottom: 18px;
        .title {
          margin-bottom: 0;
          font-size: 16px;
          color: #495057;
          font-weight: normal;
          margin-right: 14px;
        }
        .add-icon {
          color: #103f5e;
          font-size: 1.9rem;
          cursor: pointer;
        }
        .search-wrapper {
          input {
            background-color: #f2f2f2;
            padding-left: 55px;
          }
          .search-icon {
            left: 26px;
            top: 1px;
          }
        }
      }
      .sub-title {
        margin-bottom: 16px;
        color: #c7c7c7;
        font-size: 14px;
        font-weight: 500;
        padding-left: 13px;
      }
      .entities-list {
        .entity-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f7f7f7;
          padding: 20px;
          margin-left: -3px;
          border-radius: 5px;
          margin-bottom: 15px;
          .entity {
            margin-bottom: 0;
            white-space: nowrap;
          }
          .entity-width {
            width: 150px;
          }
          .actions {
            .accept {
              margin-right: 17px;
            }
            .reject {
              background-color: transparent;
              &:hover {
                background-color: #f46a6a;
              }
              &:focus {
                color: #f46a6a !important;
              }
            }
            .accept,
            .reject {
              width: 68px;
              font-size: 16px;
            }
            .go-icon {
              font-size: 1.7rem;
              color: #495057;
            }
          }
        }
      }
    }
  }
  .qr-mobile-view {
    width: 100%;
    margin-bottom: 16px;
    display: none;
    .qr {
      background-color: #f3f3f3;
      padding: 15px 30px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      width: 50%;
      margin: 0 auto;
      .qr-title {
        color: #c7c7c7;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .qr-code {
        margin: 0 auto;
        margin-bottom: 10px;
      }
      .download-text {
        color: #000;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .visit-container {
    border-radius: 8px;
    background-color: #fff;
    padding: 26px;

    .btn-visits {
      background-color: #103f5e;
      border-radius: 13px;
      font-size: 16px;
      line-height: 19px;
      border: none;
    }

    .inactive-tab {
      background: #c7c7c7 !important;
      border-radius: 13.5px !important;
      border: none;
    }
  }
  .entry-logs {
    border-radius: 8px;
    background-color: #fff;
    padding-left: 26px;
  }
  .expected-visits {
    border-radius: 8px;
    background-color: #fff;
    padding-left: 26px;
  }
  .pagination {
    margin: 0.5rem auto;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
  }
  /* Labtop L*/
  @media (max-width: 1440px) {
    .dashboard-header {
      .user-card {
        .settings {
          display: flex;
          align-items: flex-start;
          .dropdown {
            // margin-right: 3.5rem;
          }
        }
      }
    }
  }
  /* Labtop */
  @media (max-width: 1024px) {
    .dashboard-header {
      .non-system-user-card {
        .settings {
          width: 75.5%;
          .dropdown {
            margin-right: 6px !important;
          }
          .img {
            margin-right: 30px !important;
          }
        }
        .qr-wrapper {
          width: 23%;
        }
      }
      .details-card {
        .settings,
        .info {
          display: block;
          padding-left: 0;
          .user-name,
          .phone {
            padding-right: 0;
          }
          .company-email-wrapper {
            padding: 0;
            margin-top: 37px;
            &::before {
              height: 0;
            }
          }
        }
      }
      .companies-card {
        height: 674px;
        .header {
          display: block;
          .app-search {
            width: 100% !important;
          }
        }
        .entities-list {
          .entity {
            font-size: 12px !important;
          }
          .actions {
            flex-direction: column;
            justify-content: center;
            .btn {
              width: 58px !important;
              font-size: 12px !important;
            }
            .btn-success {
              margin-bottom: 3px !important;
            }
          }
        }
      }
    }
  }
  /* between */
  @media (min-width: 768px) and (max-width: 940px) {
    .non-system-user-card {
      .settings {
        display: block !important;
        width: 68% !important;
        .dropdown {
          margin-right: 6px !important;
        }
        .img {
          margin-right: 30px !important;
        }
        .user-info {
          .user-name,
          .phone {
            padding-right: 20px !important;
          }
        }
      }
      .qr-wrapper {
        width: 30% !important;
      }
    }
  }
  /* Tablet */
  @media (max-width: 768px) {
    .dashboard-header {
      display: block;
      .non-system-user-card {
        display: block;
        .settings {
          display: block;
          width: 100%;
          .dropdown,
          .img {
            display: inline-block;
            margin-bottom: 15px;
          }
          .dropdown {
            margin-right: 100px !important;
          }
          .user-info {
            width: 100%;
            .user-name,
            .phone {
              padding-right: 15px;
            }
          }
        }
        .qr-wrapper {
          width: 100%;
          flex-direction: column;
          justify-content: center;
          .qr {
            width: 40%;
            padding: 10px;
            margin: 0 auto;
            margin-bottom: 23px;
          }
          .mobile-actions {
            // display: flex;
            flex-direction: column;
            img {
              cursor: pointer;
            }
            .apple-wallet {
              margin-bottom: 20px;
            }
          }
        }
      }
      .details-card {
        width: 100%;
        margin-bottom: 20px;
      }
      .companies-card {
        height: 100%;
        overflow: hidden;
        .header {
          .title-wrapper {
            justify-content: center;
            flex-direction: row-reverse;
            .title {
              font-size: 14px;
              margin-right: 0;
              margin-left: 14px;
            }
            .add-icon {
              font-size: 1.5rem;
            }
          }
        }
        .entities-list {
          .entity-item {
            .entity {
              font-size: 14px;
            }
          }
          .invitation-item {
            padding: 0;
            background-color: transparent;
            .invitation-entity {
              font-size: 14px;
              background: #f7f7f7;
              padding: 20px;
              border-radius: 5px;
              width: 80%;
            }
          }
          .actions {
            display: block !important;
            text-align: center;
            .accept {
              margin-right: 0 !important;
              display: block;
            }
          }
        }
      }
      .user-card {
        .settings {
          display: flex;
          .qr-img-wrapper {
            .img {
              .user-avatar {
                height: 70px;
                width: 70px;
              }
            }
            .qr {
              display: none;
            }
          }
        }
      }
    }
    .qr-mobile-view {
      display: block;
    }
  }
 
  /* Mobile */
  @media (max-width: 500px) {
    .dashboard-header {
      .non-system-user-card {
        .settings {
          .dropdown {
            margin-right: 45px !important;
          }
          .user-info {
            display: block;
            margin-right: 0;
            .phone {
              margin-bottom: 37px;
            }
            .company-email-wrapper {
              padding-left: 0;
              &::before {
                height: 0;
              }
            }
          }
        }
        .qr-wrapper {
          .qr {
            width: 60%;
          }
        }
      }
    }
    .qr-mobile-view {
      .qr {
        width: 80%;
      }
    }
  }
}
</style>
